
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface BrowseHeaderProps {
  searchQuery: string;
  onSearch: (query: string) => void;
}

const BrowseHeader: React.FC<BrowseHeaderProps> = ({ searchQuery, onSearch }) => {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl md:text-4xl font-bold">Browse AI Agents</h1>
      <p className="text-lg text-muted-foreground max-w-3xl">
        Discover specialized AI agents created by our community of developers to enhance your productivity and creativity.
      </p>
      
      <div className="relative max-w-md mt-6">
        <Search className="absolute left-3 top-3 h-5 w-5 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Search agents..."
          className="pl-10 h-12"
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default BrowseHeader;
